import { EBatchGalleryCategories } from '../types/TBatchGallery';

export const batchGalleryCategories: Record<EBatchGalleryCategories, string> = {
  CATEGORY_UNSPECIFIED: 'Geral',
  COVER: 'Capa',
  LOGO: 'Logo',
};

export type TBatchGalleryCategory = 'GENERAL' | 'COVER' | 'LOGO';
